import { render, staticRenderFns } from "./replyedDetail.vue?vue&type=template&id=9bcff52a&scoped=true"
import script from "./replyedDetail.vue?vue&type=script&lang=js"
export * from "./replyedDetail.vue?vue&type=script&lang=js"
import style0 from "./replyedDetail.vue?vue&type=style&index=0&id=9bcff52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcff52a",
  null
  
)

export default component.exports